import { HStack, Text } from '@frontend/legacy-components';

interface StatusSelectorOptionLabelProps {
  icon: JSX.Element;
  text: string;
}

const StatusSelectorOptionLabel = ({
  icon,
  text,
}: StatusSelectorOptionLabelProps) => (
  <HStack spacing={0.5} alignItems="center">
    {icon}
    <Text>{text}</Text>
  </HStack>
);

export default StatusSelectorOptionLabel;
